import art from "./art/Art.js";
import mod from "./art/Model.js";
import front from "./CtpFront.js"


////////////////////////////////////////////////////////////////////////////////
// 模型：业务数据模型，用于业务逻辑处理，并为视图提供数据。
var model  = {};    // 导出
model.task = {};    // 任务管理
model.capital = new mod.OneModel();         // 资金信息
model.orderSet = new mod.SetModel();        // 委托信息
model.cancelOrderSet = new mod.SetModel();  // 撤单信息
model.tradeSet = new mod.SeqModel();        // 成交信息
model.positionSet = new mod.SetModel();     // 持仓信息
model.dominantSet = null;                   // 主力合约
model.onError = null;
export default model;

////////////////////////////////////////////////////////////////////////////////
var inner  = {};    // 私有数据


////////////////////////////////////////////////////////////////////////////////
model.error = function (e) {
    if (model.onError instanceof Function) {
        model.onError(e);
    }
}
model.onRsp = function (data, error) {
     model.error(error);
}

// 登录后清空数据模型信息，需要重新获取。
model.release = function() {
    model.capital.reset();
    model.orderSet.reset();
    model.cancelOrderSet.reset();
    model.tradeSet.reset();
    model.positionSet.reset();
    model.onError = null;
    model.dominantSet = null;
    model.trader.release();
    if(process.env.NODE_ENV === 'development')
      console.log("model.release");
}


////////////////////////////////////////////////////////////////////////////////
model.trader = {};
model.trader.queue_price_mode = 0;        // 挂单价
model.trader.match_price_mode = 1;        // 对手价
model.trader.latest_price_mode = 2;       // 最新价
model.trader.market_price_mode = 3;       // 市价
model.trader.extend_price_mode = 4;       // 超价
// 数据信息
inner.trader = {};
inner.trader.todayPosition = [];
inner.trader.todayOrder = {};

// 交易.初始化
model.trader.init = function (onError) {
    model.onError = onError;
    model.trader.queryCapital.start();
    model.trader.position.subTick();
}
// 交易.释放
model.trader.release = function () {
    inner.trader.todayOrder = {};
    inner.trader.todayPosition = [];
    model.trader.queryCapital.stop();
    model.trader.position.unsubTick();
}


//##############################################################################
////////////////////////////////////////////////////////////////////////////////
// 开始定时任务-每2秒查询查询资金账户。
model.trader.queryCapital = {};
model.trader.queryCapital.interval = 3000;
model.trader.queryCapital.start = function () {
    if (!model.trader.queryCapital.state) {
        var run = function () {
            front.queryCapital(function (capital, error) {
                if (error !== undefined) {
                    console.error(error.message);
                } else {
                    model.capital.update(capital);
                }
            });
        };
        run();  // 先查询一次，再循环定时器。
        model.trader.queryCapital.timer = setInterval(
            run, model.trader.queryCapital.interval);
        model.trader.queryCapital.state = true;
    }
};
// 停止定时任务
model.trader.queryCapital.stop = function () {
    if (model.trader.queryCapital.timer !== undefined) {
        clearInterval(model.trader.queryCapital.timer);
    }
    model.trader.queryCapital.state = false;
};


//##############################################################################
////////////////////////////////////////////////////////////////////////////////
// 交易.委托持仓，用于计算保存委托今日持仓。
inner.trader.TodayPosition = function (targetId, direct) {
    this.targetId = targetId;
    this.direction = direct;
    this.frozenLastVolume = 0;
    this.frozenTodayVolume = 0;
};


////////////////////////////////////////////////////////////////////////////////
// 交易.发布委托。
inner.trader.matchTodayPosition = function(targetId, direct, offset) {
    for (var i = 0; i < inner.trader.todayPosition.length; ++i) {
        var pos = inner.trader.todayPosition[i];
        if (pos.targetId == targetId) {
            if (pos.direction == direct &&
                offset == front.offset_open ||
                pos.direction != direct &&
                offset != front.offset_open) {
                return pos;
            }
        }
    }
};


////////////////////////////////////////////////////////////////////////////////
// 交易.发布委托。
inner.trader.findTodayPosition = function(targetId, direct) {
    for (var i = 0; i < inner.trader.todayPosition.length; ++i) {
        var pos = inner.trader.todayPosition[i];
        if (pos.targetId == targetId && pos.direction == direct) {
            return pos;
        }
    }
};


////////////////////////////////////////////////////////////////////////////////
// 交易.发布委托。
model.trader.onOrder = function (order) {
    // 统计今日平仓信息，过滤错单等非法状态的委托
    if (order.state != front.order_accepted &&
        order.state != front.order_part_canceled &&
        order.state != front.order_all_canceled &&
        order.state != front.order_part_traded &&
        order.state != front.order_all_traded &&
        order.state != front.order_error) {
        return;
    }
    order.id = order.orderRef + "#" + order.orderId;
    model.orderSet.update(order);
    if (order.state == front.order_accepted ||
        order.state == front.order_part_traded) {
        model.cancelOrderSet.update(order);
    }
    if (order.state == front.order_part_canceled ||
        order.state == front.order_all_canceled ||
        order.state == front.order_all_traded ||
        order.state == front.order_error) {
        model.cancelOrderSet.remove(order.id);
    }

    // 显示反馈信息
    if (order.state == front.order_error) {
        var text = front.textOrderState(order.state) + " "
            + order.targetId + " " + order.stateDetail;
    } else {
        var text = front.textOrderState(order.state) + " "
            + front.textDirectionOffSet(order.direction, order.offset) + " "
            + order.targetId + " " + order.volume + "手 " + order.price.toFixed(1);
    }
    if (model.notify instanceof Function) {
        model.notify(text);
    }

    // 根据状态计算冻结持仓。
    var frozenChange = 0;
    var old = inner.trader.todayOrder[order.id];
    if (old === undefined) {    // 委托不存在
        if (order.state == front.order_accepted) {
            // 未成交
            frozenChange = order.volume;
        } else if (order.state == front.order_part_traded) {
            // 部分成交
            frozenChange = order.volume - order.tradedVolume;
        } else if (order.state == front.order_all_traded) {
            // 全部成交
            frozenChange = 0;
        }
    }
    // 避免委托重复推送导致的错误：1.检测旧单子是否已完成。
    else if (
        old.state != front.order_all_canceled &&
        old.state != front.order_all_traded &&
        old.state != front.order_part_canceled &&
        old.state != front.order_error) {
        if (order.state == front.order_part_traded) {
            // 部分成交
            frozenChange = order.tradedVolume - old.tradedVolume;
        } else if (order.state == front.order_all_traded) {
            // 全部成交
            frozenChange = order.tradedVolume - old.tradedVolume;
        } else if (order.state == front.order_part_canceled) {
            // 部分撤单
            frozenChange = order.volume - old.tradedVolume;
        } else if (order.state == front.order_all_canceled) {
            // 全部撤单
            frozenChange = order.volume;
        } else if (order.state == front.order_error) {
            // 错单（场景：易盛先接收再错单）
            frozenChange = order.volume;
        }
        frozenChange *= -1;
    }
    if (frozenChange == 0) {   // 忽略未变化
        return;
    }
    inner.trader.todayOrder[order.id] = order;

    // 统计今日持仓
    if (order.offset == front.offset_close ||
        order.offset == front.offset_close_last ||
        order.offset == front.offset_close_today) {
        // 注意平仓委托的方向与其冻结持仓的方向相反。
        var rdirect = front.getReverseDirection(order.direction);
        var posDirect = front.getPositionDirection(rdirect);
        var pos = inner.trader.findTodayPosition(order.targetId, posDirect);
        if (pos === undefined) {
            pos = new inner.trader.TodayPosition(order.targetId, posDirect);
            inner.trader.todayPosition.push(pos);
        }
        if (order.offset == front.offset_close_last) {
            pos.frozenLastVolume += frozenChange;
        } else {
            pos.frozenTodayVolume += frozenChange;
        }
        model.trader.position.computeByTodayPosition(pos);    // 更新持仓信息
    }
}


////////////////////////////////////////////////////////////////////////////////
// 交易.发布成交。
model.trader.onTrade = function(trade, query_position) {
    model.tradeSet.update(trade);
    // 页面加载持仓后再查询，避免频闪。
    // 延迟500毫秒发送，因为后台持仓数据会晚于成交推送。
    if (query_position) {
        setTimeout(() => {
            model.trader.position.query(undefined, undefined, 3000);
        }, 200);
    }

    // 显示反馈信息
    var text = "[成交] "
        + front.textDirectionOffSet(trade.direction, trade.offset) + " "
        + trade.targetId + " " + trade.volume + "手 " + trade.price.toFixed(1);
    if (model.notify instanceof Function) {
        model.notify(text);
    }
}


//##############################################################################
////////////////////////////////////////////////////////////////////////////////
// 交易.查询持仓信息。
model.trader.position = {};
model.trader.position.tickSet = {};
model.trader.position.state = false;
model.trader.position.query = function(resolve, reject, millsec) {
    var positionSet = [];
    front.queryPosition("", function(pos, last) {
        if (pos) {
            var volume = pos.todayVolume + pos.lastVolume;
            if (volume > 0) {   // 过滤数量为空的持仓
                pos.id = positionSet.length;
                positionSet.push(pos);
            }
        }
        if (last) {
            model.trader.position.computePosition(positionSet);
            model.trader.position.subTick(true);
            if (resolve instanceof Function) resolve();
            if(process.env.NODE_ENV === 'development')
              console.log("position ok");
        }
    }, function(error) {
        if (resolve instanceof Function) reject(error);
    }, millsec);
};



////////////////////////////////////////////////////////////////////////////////
// 订阅持仓合约，用于实时计算持仓。
model.trader.position.subTick = function(sub_by_state) {
    if (sub_by_state && !model.trader.position.state) {
        return ;
    }
    model.trader.position.state = true;
    for (var i = 0; i < model.positionSet.array.length; ++i) {
        var pos = model.positionSet.array[i];
        front.subTick(pos.targetId, {
            suberId: "position",
            reject: model.onRsp,
            resovle: model.onRsp,
            publish: function (tick) {
                model.trader.position.tickSet[tick.targetId] = tick;
                model.trader.position.computeByMarket(tick);
            }
        });
    }
}
model.trader.position.unsubTick = function() {
    for (var i = 0; i < model.positionSet.array.length; ++i) {
        var pos = model.positionSet.array[i];
        front.unsubTick(pos.targetId, "position");
    }
    model.trader.position.state = false;
}


////////////////////////////////////////////////////////////////////////////////
// 交易.全部平仓
model.trader.position.closeAll = function () {
    // 平掉全部仓位
    var orders = [];
    for (var i = 0; i < model.positionSet.array.length; ++i) {
        var pos = model.positionSet.array[i];
        var volume = pos.todayVolume + pos.lastVolume;
        // 检查所有行情，若有值以市价平仓
        var tick = model.trader.position.tickSet[pos.targetId];
        if (tick) {
          var price = (front.getCloseOrderDirection(pos.direction) == front.direct_sell) ?
            tick.lowStopPrice : tick.highStopPrice;
          front.getCloseOrderSet(orders, pos, volume, price);
        }
    }
    return orders;
}


////////////////////////////////////////////////////////////////////////////////
// 交易.查找持仓信息。
model.trader.position.find = function(targetId, direct) {
    for (var i = 0; i < model.positionSet.array.length; ++i) {
        var pos = model.positionSet.array[i];
        if (pos.targetId == targetId && pos.direction == direct) {
            return pos;
        }
    }
};


////////////////////////////////////////////////////////////////////////////////
// 交易.计算持仓信息：今仓冻结/可用数量。
model.trader.position.computePosition = function(positionSet) {
    for (var i = 0; i< positionSet.length; ++i) {
        var pos = positionSet[i];
        // 冻结/可用数量
        pos.frozenTodayVolume = 0;
        var todayPos = inner.trader.findTodayPosition(
            pos.targetId, pos.direction);
        if (todayPos !== undefined) {
            model.trader.position.updatePositionVolume(pos, todayPos);
        }
        // 计算持仓盈亏
        var tick = model.trader.position.tickSet[pos.targetId];
        if (tick !== undefined) {
            model.trader.position.updatePositionProfit(pos, tick);
        }
    }
    model.positionSet.load(positionSet);
};
// 交易.计算持仓信息：今仓冻结/总冻结/可用数量。
model.trader.position.updatePositionVolume = function (pos, todayPos) {
    pos.frozenVolume = todayPos.frozenTodayVolume + todayPos.frozenLastVolume;
    pos.frozenTodayVolume = todayPos.frozenTodayVolume;
};
model.trader.position.computeByTodayPosition = function(todayPos) {
    var pos = model.trader.position.find(todayPos.targetId, todayPos.direction);
    if (pos !== undefined) {
        model.trader.position.updatePositionVolume(pos, todayPos);
        model.positionSet.update(pos);
    }
};
// 交易.计算持仓信息：持仓盈亏。
model.trader.position.updatePositionProfit = function (pos, tick) {
    var volume = pos.todayVolume + pos.lastVolume;
    var value = pos.multiple * volume * tick.latestPrice;
    if (pos.direction == front.pos_direct_short) {
        pos.positionProfit = pos.cost - value;
    } else {
        pos.positionProfit = value - pos.cost;
    }
};
model.trader.position.computeByMarket = function(tick) {
    for (var i = 0; i < model.positionSet.array.length; ++i) {
        var pos = model.positionSet.array[i];
        if (pos.targetId == tick.targetId) {
            model.trader.position.updatePositionProfit(pos, tick);
            model.positionSet.update(pos);
        }
    }
};



// WEBPACK FOOTER //
// ./static/js/proto/Model.js